import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-262">
      <HeroSection data-id="element-263" />
      <ProblemSection data-id="element-264" />
      <SolutionSection data-id="element-265" />
      <ContentSection data-id="element-266" />
      <VideoSection data-id="element-267" />
      <BonusSection data-id="element-268" />
      <CertificateSection data-id="element-269" />
      <OrderBumpSection data-id="element-270" />
      <TestimonialsSection data-id="element-271" />
      <PricingSection data-id="element-272" />
      <FAQSection data-id="element-273" />
      <SocialProofPopup data-id="element-274" />
    </main>;
}